<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-03 16:14:49
 * @LastEditTime: 2019-09-20 13:34:51
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div id='page_Container'>
        <div class="page">
            <div id="main-container" class="main-container">
                <div class='successHeader'>
                    <img :src="rightImg" alt="">
                    <h4>交易成功</h4>
                    <p>去评价一下本次的购物体验吧～</p>
                </div>
                <div class='btnStyle'>
                    <div class='pBox'>
                        <van-button round type="danger" size="large" @click='openEva'>立即评价</van-button>
                    </div>
                    <div class='btnBox'>
                        <van-button round size="large" @click='returnFn'>返回</van-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            rightImg: require('../assets/img/myCenter/right.png')
        };
    },
    esvReady() {
        document.title = '交易成功';
    },
    methods: {
        returnFn() {
            this.esvOpenPage({ name: 'OPMembercenter' });
        },
        openEva() {
            this.esvOpenPage('OPEvaluate');
        }
    }
};
</script>
<style lang="scss" scoped>
.successHeader {
    background: #fff;
    padding: 50px 0;
    text-align: center;
    img {
        width: 65px;
    }
    h4 {
        font-size: 20px;
        margin: 10px 0;
    }
    p {
        font-size: 14px;
        color: #999;
    }
}
.pBox {
    margin: 30px auto 10px auto;
    width: 80%;
}
.btnBox {
    margin: 0 auto;
    width: 80%;
}
</style>
